<template>
  <header class="overview-header">
    <div class="overview-header__title">
      {{ title }}
      <div v-if="hasSlotTitleExtra" class="overview-header__title-extra">
        <slot name="titleExtra"> </slot>
      </div>
    </div>

    <div class="overview-header__center">
      <slot name="center" />
    </div>

    <div class="overview-header__actions" data-test-id="overview-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { hasSlotContent } from '@components/slots';

export default defineComponent({
  name: 'OverviewHeader',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    hasSlotTitleExtra() {
      return hasSlotContent(this.$slots.titleExtra, {});
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
.overview-header {
  padding: 32px;
  display: flex;
  gap: 24px;
  align-items: center;
}

.overview-header__title {
  flex: 0 0 min-content;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  color: colors.$color-grey-800;
  white-space: nowrap;
  display: flex;
  gap: 16px;
}

.overview-header__center {
  width: 100%;
}

.overview-header__actions {
  flex: 0 0 min-content;
  margin-left: auto;
  display: flex;
  gap: 8px;
}
</style>
